import React from "react";

const ItemTable = ({
  formDetailList,
  handleChangeDetail,
  setFormDetailList,
  disabled,
}) => {
  const handleAddContactRow = () => {
    const newRow = {
      contactName: "",
      contactPhone: "",
      contactEmail: "",
    };
    setFormDetailList((prev) => [...prev, newRow]);
  };

  const handleRemoveRow = (index) => {
    setFormDetailList((prev) => prev.filter((_, i) => i !== index));
  };

  return (
    <div className="col-12">
      <div className="card">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h4 className="card-title">รายละเอียดผู้ติดต่อ</h4>
          <div>
            <button
              className="btn btn-lg  shadow text-white"
              style={{
                // marginLeft: "20px",
                backgroundColor: "#EF6C00",
                // fontSize: "16px",
              }}
              onClick={handleAddContactRow}
              type="button"
            >
              <i className="fa fa-user-plus"></i> เพิ่มผู้ติดต่อ
            </button>
          </div>
        </div>

        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-striped">
              <thead className="thead-dark">
                <tr>
                  <th className="text-center">#</th>
                  <th className="text-center">ชื่อผู้ติดต่อ</th>
                  <th className="text-center">เบอร์โทร</th>
                  <th className="text-center">อีเมล</th>
                  <th className="text-center">ลบ</th>
                </tr>
              </thead>
              <tbody>
                {formDetailList.length > 0 ? (
                  formDetailList.map((item, index) => (
                    <tr key={item.itemId || index}>
                      <td className="text-center">{index + 1}</td>
                      <td className="text-center">
                        <input
                          type="text"
                          className="form-control"
                          value={item.contactName || ""}
                          onChange={(e) =>
                            handleChangeDetail(
                              index,
                              "contactName",
                              e.target.value
                            )
                          }
                          maxLength={255}
                          disabled={disabled}
                        />
                      </td>
                      <td className="text-center">
                        <input
                          type="text"
                          className="form-control"
                          value={item.contactPhone || ""}
                          onChange={(e) =>
                            handleChangeDetail(
                              index,
                              "contactPhone",
                              e.target.value
                            )
                          }
                          maxLength={255}
                          disabled={disabled}
                        />
                      </td>
                      <td className="text-center">
                        <input
                          type="email"
                          className="form-control"
                          value={item.contactEmail || ""}
                          onChange={(e) =>
                            handleChangeDetail(
                              index,
                              "contactEmail",
                              e.target.value
                            )
                          }
                          maxLength={255}
                          disabled={disabled}
                        />
                      </td>
                      <td className="text-center">
                        <button
                          className="btn btn-danger btn-sm"
                          onClick={() => handleRemoveRow(index)}
                          disabled={disabled}
                        >
                          ลบ
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5">
                      <center>ไม่พบรายการ</center>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ItemTable;
